import type { Columns } from '@bb/sanity.types';
import { Image } from 'lucide-react';
import type { ReactNode } from 'react';
import { SanityImageComponent } from '../SanityImageComponent';
import { Pretitle, SanityWrapper, Title } from '../SanityWrapper';

export function ThreeColumn({ columns }: { columns: Columns }): ReactNode {
  return (
    <SanityWrapper>
      <div className="flex flex-col">
        <div className="mb-5 flex w-full flex-col items-center">
          {!!columns.pretitle && <Pretitle pretitle={columns.pretitle} />}
          {!!columns.title && <Title title={columns.title} />}
          {columns.description && <p>{columns.description}</p>}
        </div>
        <div className="grid grid-cols-1 gap-y-5 md:grid-cols-3 md:gap-x-4">
          {columns.columns?.map((column, i) => {
            return (
              <div
                key={column._key}
                className="flex flex-col items-center justify-between text-center"
              >
                <div className="flex max-h-full max-w-[90%] items-center justify-center rounded-md bg-gray-100 md:max-h-64 md:max-w-[16rem]">
                  {column.image ? (
                    <SanityImageComponent value={column.image} />
                  ) : (
                    <Image size={35} />
                  )}
                </div>
                <div className="mt-1 mb-auto">
                  <h3 className="title my-1! text-lg md:text-base">
                    {column.title}
                  </h3>
                  <p
                    className="px-4 text-base text-center! text-gray-600 md:text-sm"
                    style={{ textWrap: 'balance' }}
                  >
                    {column.subtitle}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </SanityWrapper>
  );
}
